/* eslint-disable */
import { v4 as uuidV4 } from 'uuid';
export default class Galeria {

  constructor () {
    this.galeria_id = uuidV4();
    this.tp_solucao_id = ''
    this.imagens= [];
    this.urls_imagem= [];
  }
}
